module.exports = "<template> <sio-phone-input value.bind=field.value></sio-phone-input> </template> ";